import type { ViewFieldsFragment } from '@salescore/client-api'
import type { ModalFuncProps } from 'antd'
import { t } from 'i18next'

import { KpiBulkDuplicateForm } from './KpiBulkDuplicateForm'

export const buildKpiBulkDuplicateModalProperties = ({
  onFinish,
  view,
}: {
  onFinish: () => void
  view: ViewFieldsFragment
}): ModalFuncProps => ({
  icon: null,
  width: '70%',
  cancelText: t(`閉じる`),
  okButtonProps: { style: { display: 'none' } },
  style: { top: '3%' },
  closable: true,
  maskClosable: true,
  destroyOnClose: true,
  content: (
    <div className="w-full overflow-x-scroll">
      {/* eslint-disable-next-line sonarjs/fixme-tag */}
      {/* FIXME: overflow-x-scroll は Windows で常時スクロールバーが表示され下部にグレー帯が出る (#8572)。overflow-x-auto への変更を検討 */}
      <KpiBulkDuplicateForm onFinish={onFinish} view={view} />
    </div>
  ),
})
